import 'regenerator-runtime/runtime';
console.log('index.js is executing!');
import { AppRegistry } from 'react-native';
import App from './App';

const appName = 'SurveyConnect';

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
